import { Link } from 'react-router-dom';

const SiteFooter = () => {
  return (
    <footer
      className="bg-[#0a0706] text-gray-500 py-12 md:py-14 px-4 md:px-6 border-t border-white/5"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center text-center">
          <span className="font-display text-3xl font-semibold tracking-tight bg-gradient-to-br from-[#c0455c] to-[#d9a15b] bg-clip-text text-transparent">
            ROJO
          </span>
          <p className="eyebrow text-gray-600 mt-2">Mens Retreat 2027</p>
          <p className="text-xs text-gray-500 mt-6">
            September 2027 · Dates coming soon · Herzl Camp · 7260 Mickey Smith Parkway, Webster, WI 54893
          </p>
          <p className="text-xs text-gray-500 mt-2">
            Questions? Email{' '}
            <a
              href="mailto:info@rojoretreat.com"
              className="text-gray-300 hover:text-white underline underline-offset-4 transition-colors"
            >
              info@rojoretreat.com
            </a>
          </p>
          <div className="mt-8 pt-6 border-t border-white/5 w-full flex items-center justify-center gap-4">
            <p className="text-[11px] text-gray-600">
              © 2026 ROJO Recovery Retreat. All rights reserved.
            </p>
            <Link
              to="/admin/login"
              className="text-[11px] text-gray-700 hover:text-gray-500 transition-colors"
              data-testid="admin-login-link"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
